/*
 This element receives product array and shows them in the select box
 */

import React from 'react'
import { useSelector, useDispatch } from "react-redux";
import {setPatternDetails} from "../../../store/details/patternDetailsSlice";
import {setPatternSides, setSideAttributeSelectionsFromSelections} from "../../../store/product/patternSelectionsSlice";

const PatternSelectorStep = (props) => {
    const dispatch = useDispatch();
    const patternCode = useSelector(state => state.patternDetailsReducer.patternCode)
    const isPattern = useSelector(state =>  state.configuratorStateReducer.isPattern)
    const patterns = useSelector(state =>  state.patternDetailsReducer.patternsAvailable)
    const patternId = useSelector(state =>  state.patternDetailsReducer.patternId)


    const generateKey = () => {
        return `configurator_pattern_selection_${ new Date().getTime() }_${ patternCode }`;
    }

    const isChecked = (value) => {
        if(!patternCode){
            return false;
        }

        return patternCode == value;
    }

    const radioButtons = () => {
        const nameGroup = `configurator_pattern_attribute_${ new Date().getTime() }`;
        return patterns.map((label, index) =>
            <li key={label.code}>
                <label className="enabled label_radio "   key={label.label}>
                    <input type="radio" key={label.code} value={label.code} defaultChecked={isChecked(label.code)} name={nameGroup} onChange={(e) => handleChange(e)}></input>
                    <b className="checkbox"></b>
                    {label.code} - {label.label}
                </label>
            </li>)
    }

    const handleChange = (event) => {
        const val = event.target.value;
        // clear side selections as then call api to get data
        dispatch(setPatternSides([]))
        dispatch(setSideAttributeSelectionsFromSelections())
        dispatch(setPatternDetails(patternId, val));
    }

    if(isPattern) {
        // const title = this.props.title;
        return (
            <div className="configurator-step pattern-selector-step" key={generateKey()}>
                <div className="row">
                    <div className="title small-12 medium-2 columns">
                        <label>Pattern</label>
                    </div>
                    <div className="selection small-12 medium-10 columns">
                        <fieldset>
                            <ul className="small-block-grid-2 product-list">
                                { radioButtons()}
                            </ul>
                        </fieldset>
                    </div>
                </div>
            </div>
        )
    } else {
        return null;
    }


}

export default PatternSelectorStep;
